
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/auth';
import { Loader2 } from 'lucide-react';

const ProtectedRoute: React.FC = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-form-blue" />
      </div>
    );
  }

  if (user) return <Outlet />;
  const target = `${location.pathname}${location.search}${location.hash}`;
  const redirect = target && target !== '/' ? `?redirect=${encodeURIComponent(target)}` : '';
  return <Navigate to={`/auth${redirect}`} replace />;
};

export default ProtectedRoute;
